import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { saveItem } from '../utils/firebaseFunctions';
import Loader from './Loader';
import Sidebar from './Sidebar';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaBars } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

const CreateContainer = () => {
  const [companyName, setCompanyName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [salary, setSalary] = useState('');
  const [salaryType, setSalaryType] = useState('');
  const [location, setLocation] = useState('');
  const [jobType, setJobType] = useState('');
  const [experienceRequired, setExperienceRequired] = useState('');
  const [postedDate, setPostedDate] = useState(new Date().toISOString().split('T')[0]);
  const [applicationDeadline, setApplicationDeadline] = useState('');
  const [numApplicants, setNumApplicants] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [field, setField] = useState(false);
  const [alertStatus, setAlertStatus] = useState('danger');
  const [msg, setMsg] = useState(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  
  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };

  // const toggleSidebar = () => {
  //   setIsSidebarOpen(!isSidebarOpen);
  // };


  const saveDetails = () => {
    setIsLoading(true);
    try {
      if (!companyName || !jobTitle || !jobDescription || !salary || !salaryType || !location || !jobType || !experienceRequired || !applicationDeadline || !numApplicants) {
        setField(true);
        setMsg("Required fields can't be empty");
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
      } else {
        const id = `${Date.now()}`; // Generate the ID here!
        const data = {
          id: id, //use the id that was just created.
          companyName,
          jobTitle,
          jobDescription,
          salary,
          salaryType,
          location,
          jobType,
          experienceRequired,
          postedDate,
          applicationDeadline,
          numApplicants,
        };
        saveItem(data);
        console.log('Data to save:', data);
        setIsLoading(false);
        setField(true);
        setMsg("Details saved successfully");
        toast.success("Details saved successfully!");
        clearData();
        setTimeout(() => {
          setField(false);
        }, 4000);
      }
    } catch (error) {
      console.error(error);
      setField(true);
      setMsg("Error while saving: Try again");
      setAlertStatus('danger');
      toast.error("Error while saving. Try again!");
      setTimeout(() => {
        setField(false);
        setIsLoading(false);
      }, 4000);
    }
  };

  const clearData = () => {
    setCompanyName('');
    setJobTitle('');
    setJobDescription('');
    setSalary('');
    setSalaryType('');
    setLocation('');
    setJobType('');
    setExperienceRequired('');
    setPostedDate(new Date().toISOString().split('T')[0]);
    setApplicationDeadline('');
    setNumApplicants('');
  };

  return (
    <div className='lg:flex h-2000 overflow-hidden lg:mt-20 mt-0'>
      <Helmet>
        <title>Create Job Listing | Nexify Infosystems</title>
        <meta name="description" content="Create a new job listing for Nexify Infosystems and manage job details including salary, job title, and location." />
      </Helmet>
      {/* <button onClick={toggleSidebar} className="md:hidden flex text-center gap-2 justify-center p-2 text-[#2c386e] text-xl">
        <FaBars /> <small className='mt-[-3px]'>Menu</small>
      </button> */}
      {/* {isSidebarOpen && <Sidebar />} */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* <div className='hidden lg:block'>
        <Sidebar className='w-64 bg-gray-200 border-r border-gray-300 absolute' />
      </div> */}
        <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10
          ${isSidebarOpen ? "ml-56 p-2 mr-[-16px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
        <div className='w-full max-w-3xl mx-auto'>
        <h1 className="lg:text-2xl text-md font-semibold mb-2 ml-4">Add Consultant job</h1>

          <div className='space-y-4 border-gray-300 rounded-lg p-4'>
            {field && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={`w-full p-2 rounded-lg text-center lg:text-[15px] text-[13px] font-semibold ${alertStatus === "danger" ? "bg-red-400 text-red-800" : "bg-green-400 text-green-800"}`}
              >
                {msg}
              </motion.p>
            )}

            {/* Company Name */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='companyName'>Company Name</label>
              <input
                id='companyName'
                type="text"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                required
                value={companyName}
                placeholder='Enter Company Name'
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>

            {/* Job Title */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='jobTitle'>Job Title</label>
              <input
                id='jobTitle'
                type="text"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                required
                value={jobTitle}
                placeholder='Enter Job Title'
                onChange={(e) => setJobTitle(e.target.value)}
              />
            </div>

            {/* Job Description - Rich Text Editor */}
            <div className='border-b border-gray-300 py-2 mb-8'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='jobDescription'>Job Description</label>
              <ReactQuill
                id='jobDescription'
                value={jobDescription}
                onChange={setJobDescription}
                placeholder='Enter Job Description'
                className="h-48 md:h-64 lg:h-72 mb-10"
                modules={{
                  toolbar: [
                    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                    ['bold', 'italic', 'underline'],
                    ['link', 'image'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    ['clean']
                  ],
                }}
              />
            </div>

            {/* Salary */}
            <div className='flex flex-col border-b border-gray-300 py-2 lg:mt-4 mt-[-10px]'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='salary'>Salary</label>
              <input
                id='salary'
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                required
                value={salary}
                placeholder='Enter Salary'
                onChange={(e) => setSalary(e.target.value)}
              />
            </div>

            {/* Salary Type */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='salaryType'>Salary Type</label>
              <select
                id='salaryType'
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                value={salaryType}
                onChange={(e) => setSalaryType(e.target.value)}
              >
                <option value=''>Select Salary Type</option>
                <option value='hourly'>Hourly</option>
                <option value='annual'>Annual</option>
                <option value='monthly'>Monthly</option>
              </select>
            </div>

            {/* Location */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='location'>Location</label>
              <input
                id='location'
                type="text"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                required
                value={location}
                placeholder='Enter Location'
                onChange={(e) => setLocation(e.target.value)}
              />
            </div>

            {/* Job Type */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='jobType'>Job Type</label>
              <select
                id='jobType'
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                value={jobType}
                onChange={(e) => setJobType(e.target.value)}
              >
                <option value=''>Select Job Type</option>
                <option value='full-time'>Full-Time</option>
                <option value='part-time'>Part-Time</option>
                <option value='contract'>Contract</option>
              </select>
            </div>

            {/* Experience Required */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='experienceRequired'>Experience Required</label>
              <input
                id='experienceRequired'
                type="text"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                required
                value={experienceRequired}
                placeholder='Enter Experience Required'
                onChange={(e) => setExperienceRequired(e.target.value)}
              />
            </div>

            {/* Posted Date */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='postedDate'>Posted Date</label>
              <input
                id='postedDate'
                type="date"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                value={postedDate}
                onChange={(e) => setPostedDate(e.target.value)}
              />
            </div>

            {/* Application Deadline */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='applicationDeadline'>Application Deadline</label>
              <input
                id='applicationDeadline'
                type="date"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                value={applicationDeadline}
                onChange={(e) => setApplicationDeadline(e.target.value)}
              />
            </div>

            {/* Number of Applicants */}
            <div className='flex flex-col border-b border-gray-300 py-2'>
              <label className='text-gray-700 lg:text-[15px] text-[13px]' htmlFor='numApplicants'>Number of Applicants</label>
              <input
                id='numApplicants'
                type="number"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900'
                required
                value={numApplicants}
                placeholder='Enter Number of Applicants'
                onChange={(e) => setNumApplicants(e.target.value)}
              />
            </div>

            {/* Save Button */}
            <button
                className="relative inline-block border border-[#005eb8] text-[#005eb8] lg:text-[15px] text-[13px] font-[500] leading-[1.5] px-[30px] py-[10px]  transition-all duration-200 hover:bg-[#005eb8] hover:text-white"
              onClick={saveDetails}
            >
              {isLoading ? <Loader /> : 'Save Job'}
            </button>
          </div>
        </div>
        
      </div>

    </div>
  );
};

export default CreateContainer;
